import React from 'react';
import classNames from 'classnames';

type Props = {
  id: string;
  className?: string;
};

export const ErrorMessage: React.FC<Props> = ({
  id,
  className,
  children,
  ...rest
}) => (
  <div
    className={classNames('text-sm text-red-500 mt-1', className)}
    id={id}
    role="alert"
    {...rest}
  >
    {children}
  </div>
);
